import DepositLink from '../src/components/DepositLink';

export default DepositLink;
